import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDescricaoMeta = '/service/contabilidade/transparencia/metaEducacao/'

class DescricaoMetaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getDescricaoResumida() {
        return this.conex.get(urlDescricaoMeta + 'descricaoResumida/')
    }
}

export default DescricaoMetaService
